import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Button, Typography } from '@mui/material';
import { BRIGHT_BLUE } from 'utils/theme';

const SeeMoreButtonText = ({ text }: { text: string }) => (
  <Typography
    color={BRIGHT_BLUE}
    fontSize="18px"
    sx={{
      display: 'inline',
    }}
  >
    {text}
  </Typography>
);

interface SeeMoreButtonProps {
  onClick: (e) => void;
  isExpanded: boolean;
}

const SeeMoreButton = ({ isExpanded, onClick }: SeeMoreButtonProps) => {
  return (
    <Button
      onClick={onClick}
      sx={{
        textTransform: 'none',
        color: BRIGHT_BLUE,
        fontSize: '18px',
        padding: 0,
        '&:hover': { background: 'none' },
      }}
      endIcon={
        isExpanded ? (
          <ExpandLessIcon sx={{ fontSize: '18px', color: BRIGHT_BLUE }} />
        ) : (
          <ExpandMoreIcon sx={{ fontSize: '18px', color: BRIGHT_BLUE }} />
        )
      }
    >
      <SeeMoreButtonText text={isExpanded ? 'See less' : 'See more'} />
    </Button>
  );
};

export default SeeMoreButton;
